export const ACCOUNT_INFO_TAB_KEYS = {
  PRIVATE_DATA: 'private-data',
  ADDRESS: 'address',
  CHANGE_PASSWORD: 'change-password',
  SUBSCRIPTION: 'subscription'
}

export const SUBSCRIPTION_OPTIONS = [
  {
    key: 'newsletterAndSms',
    langKey: 'signupNewsLetterAndSms',
    dependsOn: null
  },
  {
    key: 'newsLetter',
    langKey: 'signupNewsLetter',
    dependsOn: 'newsletterAndSms'
  },
  {
    key: 'sms',
    langKey: 'signupSms',
    dependsOn: 'newsletterAndSms'
  }
]

export const USER_UPDATE_TYPES = {
  PASSWORD: 'password_update',
  SUBSCRIPTION: 'subscription_update'
}
